/**
 * @typedef {(typeof DocumentTypeEnum)[keyof typeof DocumentTypeEnum]} DocumentTypeEnumValue
 */

/**
 * Document types used for document number sequences.
 * The values match the documentType the API returns for an order's document numbers.
 */
const DocumentTypeEnum = Object.freeze({
    GOODS_RECEIPT: 'GOODS_RECEIPT',
    RETURN_FROM_CUSTOMER: 'RETURN_FROM_CUSTOMER',
    WASTE: 'WASTE',
    DISPATCH_NOTE: 'DISPATCH_NOTE',
    RETURN_TO_SUPPLIER: 'RETURN_TO_SUPPLIER',
    STOCK_TAKE: 'STOCK_TAKE',
    GREEK_TXN_NUMBER_CUSTOMER_FACING: 'GREEK_TXN_NUMBER_CUSTOMER_FACING',
    GREEK_TXN_NUMBER_PROPOINT: 'GREEK_TXN_NUMBER_PROPOINT',
    STOCK_TRANSFER: 'STOCK_TRANSFER',
    PURCHASE_ORDER: 'PURCHASE_ORDER',
    ORDER_COLLECTION_NUMBER: 'ORDER_COLLECTION_NUMBER',
});

module.exports = DocumentTypeEnum;
